module.exports = __webpack_public_path__ + "static/media/recipe.77a2dc33.svg";